{
    "firebase": {
        "apiKey": "AIzaSyBQCCIPH1ZmKj_p_VlVG4DD5Y2lmyBByvs",
        "authDomain": "flightline-demo.firebaseapp.com",
        "projectId": "flightline-demo",
        "storageBucket": "flightline-demo.firebasestorage.app",
        "messagingSenderId": "377745278229",
        "appId": "1:377745278229:web:6a4256d4458f250513151c"
    },
    "clientName": "Demo Environment",
    "pdfViewerKey": "2ce4cb9a26e04ebd93556687712fe3db",
    "domains": ["flightline-demo.web.app"]
}
